// extracted by mini-css-extract-plugin
export default {"cls1":"Modal-cls1_eu2","cls2":"Modal-cls2_t2X Modal-cls1_eu2"};